'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations, useLocale } from 'next-intl';
import { ExternalLink } from 'lucide-react';
import logosData from '@/content/logos.json';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
type Logo = {
  name: string;
  image: string;
  alt: {
    en: string;
    fr: string;
    nl: string;
    es: string;
    it: string;
  };
  description: {
    en: string;
    fr: string;
    nl: string;
    es: string;
    it: string;
  };
  website: string;
  season: 'summer' | 'winter' | 'both';
  featured: 'home' | 'summer' | 'winter' | '';
  onSale: boolean;
  category: 'rental' | 'accessories' | 'both';
  scale?: number;
};
type LogoCloudProps = {
  season?: 'summer' | 'winter' | 'both';
  category?: 'rental' | 'accessories';
  titleKey?: string;
  subtitleKey?: string;
};
export default function LogoCloud(t0) {
  const $ = _c(42);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    season,
    category,
    titleKey,
    subtitleKey
  } = t1;
  const t = useTranslations("Partners");
  const locale = useLocale();
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== category || $[3] !== locale || $[4] !== season || $[5] !== subtitleKey || $[6] !== t || $[7] !== titleKey) {
    let logos = logosData.logos as Logo[];
    if (season && season !== "both") {
      let t8;
      if ($[14] !== season) {
        t8 = logo => logo.season === season || logo.season === "both";
        $[14] = season;
        $[15] = t8;
      } else {
        t8 = $[15];
      }
      logos = logos.filter(t8);
    }
    if (category) {
      let t8;
      if ($[16] !== category) {
        t8 = logo_0 => logo_0.category === category || logo_0.category === "both";
        $[16] = category;
        $[17] = t8;
      } else {
        t8 = $[17];
      }
      logos = logos.filter(t8);
    }
    let t8;
    if ($[18] !== t || $[19] !== titleKey) {
      t8 = titleKey ? t(titleKey) : "";
      $[18] = t;
      $[19] = titleKey;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    const title = t8;
    let t9;
    if ($[21] !== subtitleKey || $[22] !== t) {
      t9 = subtitleKey ? t(subtitleKey) : "";
      $[21] = subtitleKey;
      $[22] = t;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    const subtitle = t9;
    t7 = "py-20 md:py-24";
    t4 = "mx-auto max-w-7xl px-4 sm:px-6";
    if ($[24] !== title) {
      t5 = title && <h2 className="text-center text-4xl md:text-6xl font-bold mb-2 max-w-5xl mx-auto font-[family-name:var(--font-bebas-neue)]">{title}</h2>;
      $[24] = title;
      $[25] = t5;
    } else {
      t5 = $[25];
    }
    if ($[26] !== subtitle) {
      t6 = subtitle && <p className="text-center text-base md:text-lg text-foreground/90 mt-4 max-w-3xl mx-auto">{subtitle}</p>;
      $[26] = subtitle;
      $[27] = t6;
    } else {
      t6 = $[27];
    }
    t2 = `mx-auto ${title ? "mt-16" : "mt-0"} flex max-w-5xl flex-wrap items-center justify-center gap-x-4 gap-y-8 sm:gap-x-8 sm:gap-y-10 lg:gap-x-10 [--logo-h:1.75rem] sm:[--logo-h:2.25rem]`;
    let t10;
    if ($[28] !== locale || $[29] !== t) {
      t10 = (logo_1, index) => {
        const description = logo_1.description[locale as keyof typeof logo_1.description] || logo_1.description.en;
        return <Popover key={index}><PopoverTrigger asChild={true}><button className="flex w-24 sm:w-28 lg:w-32 items-center justify-center cursor-pointer transition-transform hover:scale-110 duration-200 bg-transparent border-0 p-0" onMouseEnter={_temp}><img src={logo_1.image} alt={description} loading="lazy" style={{
                height: `calc(var(--logo-h) * ${logo_1.scale ?? 1})`
              }} className="w-auto max-w-full object-contain" /></button></PopoverTrigger><PopoverContent className="w-80 bg-background/95 backdrop-blur-sm border-2" side="top"><div className="space-y-4"><p className="text-sm text-foreground/90 leading-relaxed">{description}</p><a href={logo_1.website} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline">{t("visitWebsite")}<ExternalLink className="h-3 w-3" /></a></div></PopoverContent></Popover>;
      };
      $[28] = locale;
      $[29] = t;
      $[30] = t10;
    } else {
      t10 = $[30];
    }
    t3 = logos.map(t10);
    $[2] = category;
    $[3] = locale;
    $[4] = season;
    $[5] = subtitleKey;
    $[6] = t;
    $[7] = titleKey;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  if ($[31] !== t2 || $[32] !== t3) {
    t8 = <div className={t2}>{t3}</div>;
    $[31] = t2;
    $[32] = t3;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== t4 || $[35] !== t5 || $[36] !== t6 || $[37] !== t8) {
    t9 = <div className={t4}>{t5}{t6}{t8}</div>;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t8;
    $[38] = t9;
  } else {
    t9 = $[38];
  }
  let t10;
  if ($[39] !== t7 || $[40] !== t9) {
    t10 = <section className={t7}>{t9}</section>;
    $[39] = t7;
    $[40] = t9;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  return t10;
}
function _temp(e) {
  if (window.innerWidth >= 768) {
    e.currentTarget.click();
  }
}